const data = (collection, keyword, sessionType, enterprise) => (
  collection && collection.length > 0
  && Object.values(collection).filter((item) => {
    let available = false;

    if (
      item && (
        item.chat_info.user_name
          .toLowerCase()
          .includes(keyword.toLowerCase())
        || item.chat_info.avatar_name
          .toLowerCase()
          .includes(keyword.toLowerCase())
        || item.chat_info.user_email.toLowerCase().includes(keyword.toLowerCase())
      )
      && (
        sessionType === null || item.chat_info.session_type
          .toLowerCase() === sessionType.value
      )
      && (
        item.chat_info.enterprise
          .toLowerCase()
          .includes(enterprise.toLowerCase())
      )
    ) available = true;

    return available;
  })
);

export default data;
